import { createHttpClient } from "./client";

function normalizePalettes(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.records)) return payload.records;

  if (payload && typeof payload === "object") {
    return Object.entries(payload).map(([key, value]) => ({
      key,
      label: value?.label || value?.name || key,
      ...value
    }));
  }
  return [];
}

/**
 * 图纸工作台接口封装。
 * 后续切换到你自己的接口时，优先保持方法签名不变，只替换实现即可。
 */
export function createStudioApi(baseUrl) {
  const http = createHttpClient(baseUrl);

  return {
    /**
     * 获取品牌色卡列表，用于下拉与初始化。
     */
    async fetchPalettes() {
      const payload = await http.get("/quark/bead/palettes");
      return normalizePalettes(payload);
    },

    /**
     * 执行图纸处理模式。
     * mode 可选：
     * - simple-pattern
     * - color-recognition
     * - batch-colors
     * - pro-pattern
     */
    requestMode(mode, file, payload) {
      const form = new FormData();
      form.append("file", file);
      Object.entries(payload).forEach(([key, value]) => {
        form.append(key, String(value));
      });
      return http.post(`/quark/bead/modes/${mode}`, form, {
        headers: { "Content-Type": "multipart/form-data" }
      });
    }
  };
}


